// Chromeが「getImageDataを繰り返すなら willReadFrequently: true を指定しろ」と警告する対策。
// OpenLayers 5 などcanvas2dを使う多くのライブラリがこのattributeを渡しておらず、
// 警告のたびにGPU↔CPUのpixel readbackが発生してパフォーマンスを落とすため、
// グローバルに getContext('2d', ...) に willReadFrequently: true を注入する。
// OLなどのimportより前に評価される必要があるので、main.tsの先頭で読み込むこと。
if (typeof HTMLCanvasElement !== 'undefined') {
  const origGetContext = HTMLCanvasElement.prototype.getContext;
  HTMLCanvasElement.prototype.getContext = function(
    this: HTMLCanvasElement,
    contextId: string,
    options?: unknown,
  ) {
    if (contextId === '2d') {
      // 呼び出し側が明示的に指定している場合はそちらを尊重し、未指定ならtrueにする
      options = { willReadFrequently: true, ...(options as Record<string, unknown>) };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return (origGetContext as any).call(this, contextId, options);
  } as typeof HTMLCanvasElement.prototype.getContext;
}
